export default function AuditLogs() {
    const testLogs = [
        {"event": "User access /Name", "message": "User 123 accessed endpoint /Name", "timeStamp": new Date() }
    ];

    return testLogs.map( (ev, ind) => <li key={ind}>
        {ev.event} {ev.message}
    </li>);

}
